import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { setAuthenticatedUser } from 'services/appInsights/appInsights';

import authConfigInstance from './authServise';

export const getUserToken = async (forceRefresh = false): Promise<string | undefined | void> => {
  try {
    const accessTokenResponse = await authConfigInstance.getToken(forceRefresh);
    if (accessTokenResponse) {
      setAuthenticatedUser(
        accessTokenResponse.account.username,
        accessTokenResponse.account.localAccountId,
      );

      return accessTokenResponse.accessToken;
    }

    // No token response — AuthService will have triggered a redirect if needed
    return undefined;
  } catch (error) {
    console.error('~~~~~ token ERROR ~~~~~ %o', error);
    if (error instanceof InteractionRequiredAuthError) {
      // AuthService already handles this, but as a safety net:
      await authConfigInstance.signIn();
    }

    return undefined;
  }
};
